import { useAppDispatch, useAppSelector } from '@store/hooks'
import { deleteEventParticipation } from '@store/membership/EventParticipationReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Delete from './Delete'
import View from './View'

export const ParticipationForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.eventParticipation)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        delete: Delete,
        view: View,
      }}
      handlers={{
        delete: async (values) =>
          dispatch(deleteEventParticipation(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

ParticipationForm.displayName = 'ParticipationForm'

export type ParticipationFormType = { Form: typeof ParticipationForm }
